import script from "./CommentHistoryContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentHistoryContent.vue?vue&type=script&setup=true&lang=ts"

import "./CommentHistoryContent.vue?vue&type=style&index=0&id=3a82c451&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a82c451"]])

export default __exports__